// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/kycb/api/kyc_verification/firstparty/v3/setup_kyc.proto

/* oxlint-disable */

/** Request message for SetupKyc. */
export interface ApiSetupKycRequest {
  /** The ID of the membership to setup KYC for (UUID format). */
  readonly membershipId: string;
  /** The Qonto app web URL to which the user will be redirected once the KYC process is finished. */
  readonly qontoRedirectionUrl?: string | null | undefined;
}

/** Response message for SetupKyc. */
export interface ApiSetupKycResponse {
  /** The ID of the membership the KYC was set up for (UUID format). */
  readonly membershipId: string;
  /** The URL of the Qonto verification app to redirect the user to for the standalone KYC process. */
  readonly verificationUrl: string;
  /** The Qonto app web URL to which the user will be redirected once the KYC process is finished. */
  readonly qontoRedirectionUrl?: string | null | undefined;
}

/** Error definitions for SetupKyc. */
export interface ApiSetupKycErrors {
}

/** Not found error codes. */
export const ApiSetupKycErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error. */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND - Membership with the given ID was not found. */
  NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND: "NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND",
} as const;

export type ApiSetupKycErrorsNotFoundError =
  typeof ApiSetupKycErrorsNotFoundError[keyof typeof ApiSetupKycErrorsNotFoundError];

export namespace ApiSetupKycErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiSetupKycErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND =
    typeof ApiSetupKycErrorsNotFoundError.NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND;
}

export function apiSetupKycErrorsNotFoundErrorFromJSON(object: any): ApiSetupKycErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiSetupKycErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND":
      return ApiSetupKycErrorsNotFoundError.NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND;
    default:
      return ApiSetupKycErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiSetupKycErrorsNotFoundErrorToJSON(object: ApiSetupKycErrorsNotFoundError): string {
  switch (object) {
    case ApiSetupKycErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiSetupKycErrorsNotFoundError.NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND:
      return "NOT_FOUND_ERROR_MEMBERSHIP_NOT_FOUND";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Forbidden error codes. */
export const ApiSetupKycErrorsForbiddenError = {
  /** FORBIDDEN_ERROR_UNSPECIFIED - Unspecified forbidden error. */
  FORBIDDEN_ERROR_UNSPECIFIED: "FORBIDDEN_ERROR_UNSPECIFIED",
  /** FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED - The membership does not belong to the authenticated user. */
  FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED: "FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED",
} as const;

export type ApiSetupKycErrorsForbiddenError =
  typeof ApiSetupKycErrorsForbiddenError[keyof typeof ApiSetupKycErrorsForbiddenError];

export namespace ApiSetupKycErrorsForbiddenError {
  export type FORBIDDEN_ERROR_UNSPECIFIED = typeof ApiSetupKycErrorsForbiddenError.FORBIDDEN_ERROR_UNSPECIFIED;
  export type FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED =
    typeof ApiSetupKycErrorsForbiddenError.FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED;
}

export function apiSetupKycErrorsForbiddenErrorFromJSON(object: any): ApiSetupKycErrorsForbiddenError {
  switch (object) {
    case 0:
    case "FORBIDDEN_ERROR_UNSPECIFIED":
      return ApiSetupKycErrorsForbiddenError.FORBIDDEN_ERROR_UNSPECIFIED;
    case 1:
    case "FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED":
      return ApiSetupKycErrorsForbiddenError.FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED;
    default:
      return ApiSetupKycErrorsForbiddenError.FORBIDDEN_ERROR_UNSPECIFIED;
  }
}

export function apiSetupKycErrorsForbiddenErrorToJSON(object: ApiSetupKycErrorsForbiddenError): string {
  switch (object) {
    case ApiSetupKycErrorsForbiddenError.FORBIDDEN_ERROR_UNSPECIFIED:
      return "FORBIDDEN_ERROR_UNSPECIFIED";
    case ApiSetupKycErrorsForbiddenError.FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED:
      return "FORBIDDEN_ERROR_MEMBERSHIP_NOT_OWNED";
    default:
      return "FORBIDDEN_ERROR_UNSPECIFIED";
  }
}

/** Unprocessable entity error codes. */
export const ApiSetupKycErrorsUnprocessableEntityError = {
  /** UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED - Unspecified unprocessable entity error. */
  UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED: "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED",
  /** UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID - The membership_id field is missing from the request. */
  UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID: "UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID",
  /** UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL - The qonto_redirection_url is not a valid Qonto domain URL. */
  UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL: "UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL",
  /** UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP - The membership is invalid for KYC setup. */
  UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP: "UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP",
} as const;

export type ApiSetupKycErrorsUnprocessableEntityError =
  typeof ApiSetupKycErrorsUnprocessableEntityError[keyof typeof ApiSetupKycErrorsUnprocessableEntityError];

export namespace ApiSetupKycErrorsUnprocessableEntityError {
  export type UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED =
    typeof ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  export type UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID =
    typeof ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID;
  export type UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL =
    typeof ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL;
  export type UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP =
    typeof ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP;
}

export function apiSetupKycErrorsUnprocessableEntityErrorFromJSON(
  object: any,
): ApiSetupKycErrorsUnprocessableEntityError {
  switch (object) {
    case 0:
    case "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED":
      return ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
    case 1:
    case "UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID":
      return ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID;
    case 2:
    case "UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL":
      return ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL;
    case 3:
    case "UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP":
      return ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP;
    default:
      return ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  }
}

export function apiSetupKycErrorsUnprocessableEntityErrorToJSON(
  object: ApiSetupKycErrorsUnprocessableEntityError,
): string {
  switch (object) {
    case ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
    case ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID:
      return "UNPROCESSABLE_ENTITY_ERROR_MISSING_MEMBERSHIP_ID";
    case ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL:
      return "UNPROCESSABLE_ENTITY_ERROR_INVALID_REDIRECTION_URL";
    case ApiSetupKycErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP:
      return "UNPROCESSABLE_ENTITY_ERROR_INVALID_MEMBERSHIP";
    default:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
  }
}

export const ApiSetupKycRequest: MessageFns<ApiSetupKycRequest> = {
  fromJSON(object: any): ApiSetupKycRequest {
    return {
      membershipId: isSet(object.membership_id) ? globalThis.String(object.membership_id) : "",
      qontoRedirectionUrl: isSet(object.qonto_redirection_url) ? globalThis.String(object.qonto_redirection_url) : null,
    };
  },

  toJSON(message: ApiSetupKycRequest): unknown {
    const obj: any = {};
    if (message.membershipId !== undefined && message.membershipId !== null) {
      obj.membership_id = message.membershipId;
    }
    if (message.qontoRedirectionUrl !== undefined && message.qontoRedirectionUrl !== null) {
      obj.qonto_redirection_url = message.qontoRedirectionUrl;
    }
    return obj;
  },
};

export const ApiSetupKycResponse: MessageFns<ApiSetupKycResponse> = {
  fromJSON(object: any): ApiSetupKycResponse {
    return {
      membershipId: isSet(object.membership_id) ? globalThis.String(object.membership_id) : "",
      verificationUrl: isSet(object.verification_url) ? globalThis.String(object.verification_url) : "",
      qontoRedirectionUrl: isSet(object.qonto_redirection_url) ? globalThis.String(object.qonto_redirection_url) : null,
    };
  },

  toJSON(message: ApiSetupKycResponse): unknown {
    const obj: any = {};
    if (message.membershipId !== undefined && message.membershipId !== null) {
      obj.membership_id = message.membershipId;
    }
    if (message.verificationUrl !== undefined && message.verificationUrl !== null) {
      obj.verification_url = message.verificationUrl;
    }
    if (message.qontoRedirectionUrl !== undefined && message.qontoRedirectionUrl !== null) {
      obj.qonto_redirection_url = message.qontoRedirectionUrl;
    }
    return obj;
  },
};

export const ApiSetupKycErrors: MessageFns<ApiSetupKycErrors> = {
  fromJSON(_: any): ApiSetupKycErrors {
    return {};
  },

  toJSON(_: ApiSetupKycErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
